import Document from "components/Document";
import authPage from "hocs/authPage";
import { VERBIAGE_LABEL } from "utilities/constants";

export default authPage({
  title: [VERBIAGE_LABEL?.DOCUMENTATION],
  offsets: 2,
  route: "/profile/back",
})(Document);
